const getValidFormData = (additionalFields = {}) => {
  return {
    ...additionalFields,
  };
};

export default getValidFormData;
